module.exports = __webpack_public_path__ + "images/emoji/it.3b0fe57d0739542dd8a5.png";